// extracted by mini-css-extract-plugin
module.exports = {"DropDown":"DropDown_DropDown__3V9sJ","open":"DropDown_open__1oLqZ","list":"DropDown_list__1n5ex","item":"DropDown_item__2Pnwv","link":"DropDown_link__222Pn"};